module.exports = __webpack_public_path__ + "img/41.0483a2e0.jpg";